export enum Env {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  TEST = 'test',
}



// WEBPACK FOOTER //
// ./src/constants/env.ts